import { render, staticRenderFns } from "./setS3CredentialsModal.vue?vue&type=template&id=7af49b7c&scoped=true"
import script from "./setS3CredentialsModal.vue?vue&type=script&lang=js"
export * from "./setS3CredentialsModal.vue?vue&type=script&lang=js"
import style0 from "./setS3CredentialsModal.vue?vue&type=style&index=0&id=7af49b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af49b7c",
  null
  
)

export default component.exports